import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';

import translationFR from './fr.json';
import translationES from './es.json';
import translationIT from './it.json';
import translationPT from './pt.json';
import translationBEFR from './be_fr.json';
import translationBENL from './be_nl.json';
import translationNL from './nl.json';

// the translations resources
const resources = {
    fr: {
        translation: translationFR,
    },
    es: {
        translation: translationES,
    },
    it: {
        translation: translationIT,
    },
    pt: {
        translation: translationPT,
    },
    be_fr: {
        translation: translationBEFR,
    },
    be_nl: {
        translation: translationBENL,
    },
    nl: {
        translation: translationNL,
    },
};

i18n.use(detector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'fr',
        detection: {
            order: ['navigator'],
            caches: ['localStorage', 'cookie'],
        },
    });

export default i18n;
